<template>
  <div class="advertise_container" v-show="modelValue" @click.stop @touchmove.stop.prevent>
    <swiper :modules="modules" :centeredSlides="true" loop autoplay class="banner_wrapper" :pagination="pagination">
      <swiper-slide v-for="(item, index) in data.slice(0, 3)" :key="index" @click="skipHandle(item)">
        <img :src="item.appImgUrl" class="banner_img" />
      </swiper-slide>
    </swiper>

    <div class="close_icon" @click="closeHandle">
      <i class="iconfont icon-icon_wode_wodepeixun_kejianyulan_guanbi" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Pagination } from 'swiper'
import { useThemeColor } from '@/utils/theme'
import { Record } from '@/api/Models/HomeAdvertiseList'
import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'

defineProps<{
  data: Record[]
  modelValue: boolean
}>()
const commits = defineEmits(['update:modelValue'])

const closeHandle = () => {
  commits('update:modelValue', false)
}

const router = useRouter()
const skipHandle = (item: Record) => {
  commits('update:modelValue', false)
  switch (
    item.appJumpStatus // 链接
  ) {
    case 1:
      handleExternalUrl({ jumpUrl: item.appJumpUrl })
      break
    case 2:
      router.push({
        // 课程
        name: 'courseDetail',
        query: {
          id: item.appJumpUrl,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: item.appJumpCourseType === 0 ? 'course' : 'courseWare'
        }
      })
      break
    case 3: // 资讯
      router.push('/broadcastDetail/' + item.appJumpUrl)
      break
    case 4: // 培训
      router.push('/trainingDetail?id=' + item.appJumpUrl)
      break
    case 5: // 考试
      router.push('/examInfo?examId=' + item.appJumpUrl)
      break
    case 6: // 调查
      router.push('/surveyInfo?investigationId=' + item.appJumpUrl)
      break
    default:
      break
  }
}

const modules = [Autoplay, Pagination]
const themeColor = useThemeColor()
const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return '<span class="' + className + '"></span>'
  }
}
</script>

<style lang="less" scoped>
@import url('@/styles/variables.less');
.advertise_container {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 4000;
  display: flex;
  flex-direction: column;
  .flex_center;
  .banner_wrapper {
    border-radius: 8px;
    width: 270px;
    height: 480px;
  }
  .banner_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .close_icon {
    margin-top: 10px;
    .iconfont {
      color: #fff;
      font-size: 30px;
    }
  }
}
:deep(.swiper-pagination) {
  position: absolute;
  bottom: 12px;
  left: 12px;
  z-index: 10;
  display: flex;
  align-items: center;
}
:deep(.swiper-pagination-bullet) {
  width: 8px;
  height: 2px;
  background: #ffffff;
  border-radius: 1px;
  margin-right: 4px;
}
:deep(.swiper-pagination-bullet-active) {
  height: 3px;
  background: v-bind(themeColor);
}
</style>
